import "../translations/i18n";
import { Link } from "react-router-dom";

export const Service = (props) => {
  const services = [
    {
      icon: "bi bi-camera-video",
      title: "Production video",
      text: "Reportages, interviews, reels et capsules courtes pour garder une image vivante."
    },
    {
      icon: "bi bi-palette",
      title: "Branding digital",
      text: "Visuels, campagnes, formats sociaux et direction graphique pour une marque plus nette."
    },
    {
      icon: "bi bi-newspaper",
      title: "Media et actualites",
      text: "Articles, couvertures terrain et contenus editoriaux pour informer avec credibilite."
    },
  ];

  return (
    <section id="services" className="services dashboard-services">
      <div className="container" data-aos="fade-up">
        <div className="row align-items-center gy-5">
          <div className="col-lg-5" data-aos="fade-right">
            <div className="dashboard-section-copy">
              <span className="dashboard-kicker">Qui sommes nous ?</span>
              <h2>Un studio qui donne du poids visuel aux marques et aux idees.</h2>
              <p>
                B-eye accompagne les entreprises, institutions et porteurs de projets avec une
                production multimedia claire, actuelle et exploitable sur plusieurs canaux.
              </p>
              <div className="dashboard-service-list">
                <span><i className="bi bi-check2-circle"></i> Reportage et couverture terrain</span>
                <span><i className="bi bi-check2-circle"></i> Contenu social media et branding</span>
                <span><i className="bi bi-check2-circle"></i> Diffusion web et communication digitale</span>
              </div>
              <a href="#portfolio" className="dashboard-service-cta">
                Voir nos realisations <i className="bi bi-arrow-right"></i>
              </a>
            </div>
          </div>

          <div className="col-lg-7" data-aos="fade-left" data-aos-delay="100">
            <div className="dashboard-video">
              <div className="dashboard-video__badge">
                <i className="bi bi-play-fill"></i>
                Presentation
              </div>
              <video controls>
                  <source src='/img/vd.MP4'  type='video/mp4' />
                  Votre navigateur ne supporte pas la lecture des videos.
              </video>
            </div>
          </div>
          <div className="col-12">
            <div className="dashboard-service-cards">
              {services.map((service, index) => (
                <div className="dashboard-service-card" key={service.title} data-aos="fade-up" data-aos-delay={(index + 1) * 80}>
                  <i className={service.icon}></i>
                  <h3>{service.title}</h3>
                  <p>{service.text}</p>
                </div>
              ))}
            </div>
          </div>
          {props.articles.map((article) => {
            return (
              <div className="col-lg-3 col-md-6" key={article.id}>
                <div className="service-item position-relative">
                  <div className="icon" style={{ color : "red"}}>
                    <i className={article.category.icone} style={{ color : "red"}}></i>
                  </div>
                  <h3>{article.category.name}</h3>
                  <p>{article.category.description}</p>
                  <Link
                    to={"/articles/" + article.id}
                    className="readmore stretched-link"
                  >
                    Voir plus <i className="bi bi-arrow-right"></i>
                  </Link>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
